import request, { ResponseProps } from '@/utils/request';

type StripeSinglePayResult = ResponseProps<{
  nonceStr: string;
  orderId: string;
  webUrl: string;
}>;

type StripeSinglePollingResult = ResponseProps<'unpaid' | 'success' | string>;

export const stripeSinglePay = async (data: {}): Promise<StripeSinglePayResult> => {
  const res: StripeSinglePayResult = await request('/api/rest/dlt/commerce/prepayment', {
    method: 'POST',
    data,
  });
  return res;
};

export const stripeSinglePolling =
  async (data: {}): Promise<StripeSinglePollingResult> => {
    const res: StripeSinglePollingResult = await request(
      '/api/rest/dlt/commerce/order/query',
      {
        method: 'POST',
        data,
      },
    );
    return res;
  };

type StripePayResult = {
  [K in keyof ResponseProps]: K extends 'data'
    ? {
        amount: number;
        contractCode: string;
        currencyCode: string;
        redirectUrl: string;
        subscribeId: string;
      }
    : ResponseProps[K];
};
// stripe支付
export const stripeSubscribePay = async (data: {}): Promise<StripePayResult> => {
  const res: StripePayResult = await request('/api/rest/dlt/commerce/subscribe', {
    method: 'POST',
    data,
  });
  return res;
};

type StripePayDetail = {
  [K in keyof ResponseProps]: K extends 'data'
    ? {
        status: 'SUCCESS' | 'CANCEL' | 'UNKNOWN' | 'FAILED' | undefined | null;
        redirectUrl: string;
        expireTime: number;
      }
    : ResponseProps[K];
};
// stripe 订阅状态查询
export const stripeSubscribePolling = async (data?: {}): Promise<StripePayDetail> => {
  const res: StripePayDetail = await request('/api/rest/dlt/commerce/thirdStatus', {
    method: 'POST',
    data,
  });
  return res;
};
